"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHandlerBase = void 0;
class HttpHandlerBase {
    SendAsync(requestInfo, requestInit) {
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            if (requestInit) {
                if (requestInit.setSignal && requestInit.clearTimeout) {
                    requestInit.setSignal();
                    response = yield fetch(requestInfo, requestInit);
                    requestInit.clearTimeout();
                }
                else {
                    response = yield fetch(requestInfo, requestInit);
                }
            }
            else {
                response = yield fetch(requestInfo);
            }
            if (!response.ok) {
                let error;
                try {
                    const almeErrorResponse = yield response.json();
                    error = new Error(almeErrorResponse.Message);
                }
                catch (_a) {
                    error = new Error('An error has occurred.');
                }
                error.httpStatusCode = response.status;
                throw error;
            }
            //No Content
            if (response.status === 204) {
                return;
            }
            const json = yield response.json();
            return json;
        });
    }
}
exports.HttpHandlerBase = HttpHandlerBase;
//# sourceMappingURL=HttpHandlerBase.js.map


// WEBPACK FOOTER //
// ../HttpHandlerBase.ts